// extracted by mini-css-extract-plugin
export default {"root":"SuccessMessageWizardStep_root__9PS+w","title":"SuccessMessageWizardStep_title__N5RSP","subtitle":"SuccessMessageWizardStep_subtitle__v6G8X"};